import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {SearchValuationResult, SearchValuationsRequest} from "../payload-types/search-valuation";

/**
 * API interface for the valuations search (POST {@link RevaApi.PATH_VALUATIONS_SEARCH}).
 * Sends paging/sorting/filter parameters as a JSON body and returns the paged result.
 */
export class SearchValuationsApiInterface extends SimpleApiInterface<SearchValuationResult> {
    /**
     * @param request Paging-/Sortier-/Status-/Tab-Parameter
     * @param options der globale Freitextfilter (liegt außerhalb der Per-Tab-Params) und ein optionales
     *                AbortSignal, damit ein neuerer Tastendruck diese laufende Suche abbrechen kann
     */
    constructor(
        private readonly request: SearchValuationsRequest,
        private readonly options: {freeText?: string | null; signal?: AbortSignal} = {},
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS_SEARCH]);
    }

    protected buildPayload(): Record<string, unknown> {
        // Omit empty filters (null → undefined) so JSON.stringify drops them from the request body.
        const r = this.request;
        return {
            pageIndex: r.pageIndex,
            pageSize: r.pageSize,
            sortField: r.sortField,
            sortOrder: r.sortOrder,
            filterLifeCycleState: r.filterLifeCycleState?.length ? r.filterLifeCycleState : undefined,
            filterTab: r.filterTab ?? undefined,
            filterFreeText: this.options.freeText ?? undefined,
        };
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<SearchValuationResult> {
        return executor.fetchPOST(url, credentials, this.buildPayload(), this.options.signal);
    }
}
